import { HideableFilterGroup } from "@/routes/app/-components/hideable-filter-group"
import { Route } from ".."
import { LoggingTable } from "../-components/logging-table"
import { Page } from "../../../../../-components/Page"

export function LoggingTablePage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const [showFilters, setShowFilters] = React.useState(false)
  return (
    <Page
      buttonGroupProps={{
        children: (
          <HideableFilterGroup.Button
            visible={showFilters}
            onChange={() => setShowFilters((v) => !v)}
            activeFilters={
              (search.level ? 1 : 0) +
              (search.userId ? 1 : 0) +
              (search.start && search.end ? 1 : 0)
            }
          />
        ),
      }}
    >
      <LoggingTable
        searchProps={{
          value: search,
          onChange: (value) =>
            navigate({
              search: { ...search, ...value },
              replace: true,
            }),
        }}
        showFilters={showFilters}
      />
    </Page>
  )
}
